module.exports = __webpack_public_path__ + "img/legend_d.56a06da2.png";